import { registerUser, generateConfirmationDetails, confirmUser } from './apiService';

export const handleUserFlow = async (
  userDetails,
  packageDetails,
  setIsModalVisible,
  setConfirmationDetails,
  getConfirmationDetails
) => {
  try {
    // Step 1: Register the user
    const registeredUser = await registerUser(userDetails);

    // Step 2: Generate confirmation details
    const confirmationDetails = generateConfirmationDetails(registeredUser, userDetails);

    // Step 3: Wait for OTP input via modal
    const updatedConfirmationDetails = await getConfirmationDetails(confirmationDetails);

    // Step 4: Confirm user
    await confirmUser(updatedConfirmationDetails);

    // Return user & OTP-confirmed details for subscription creation
    return { updatedConfirmationDetails, registeredUser };
  } catch (error) {
    console.error('Error in user flow:', error);
    throw error;
  }
};